import { initializeApp, getApps, getApp, deleteApp, FirebaseApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY || "AIzaSyAh4IcD0blpIA5bmVMIxFZ6DtPKwZtGi8Q",
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN || "datacode-327ec.firebaseapp.com",
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || "datacode-327ec",
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET || "datacode-327ec.firebasestorage.app",
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || "744362519176",
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID || "1:744362519176:web:1c7258b5e1a1d8ea460d3d",
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID || "G-BNRBXTBEP6"
};

// Initialize Firebase only if it hasn't been initialized yet
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Initialize services
const storage = getStorage(app);
const auth = getAuth(app);
const db = getFirestore(app);

// Route Firestore to the local emulator during e2e runs. We gate on a
// public env flag (baked into the static build) so prod bundles never
// route to 127.0.0.1. `connectFirestoreEmulator` is idempotent-unsafe —
// only call it once per app instance.
if (
  typeof window !== 'undefined' &&
  process.env.NEXT_PUBLIC_USE_FIRESTORE_EMULATOR === '1'
) {
  const w = window as unknown as { __FS_EMULATOR_WIRED__?: boolean };
  if (!w.__FS_EMULATOR_WIRED__) {
    const host = process.env.NEXT_PUBLIC_FIRESTORE_EMULATOR_HOST || '127.0.0.1';
    const port = Number(process.env.NEXT_PUBLIC_FIRESTORE_EMULATOR_PORT || 8080);
    connectFirestoreEmulator(db, host, port);
    w.__FS_EMULATOR_WIRED__ = true;
  }
}

// Create a secondary Firebase app for creating users without signing in
// This is used to create new admin users without affecting the current user's session
export const getSecondaryApp = (): FirebaseApp => {
  try {
    return getApp('secondary');
  } catch {
    return initializeApp(firebaseConfig, 'secondary');
  }
};

// Clean up secondary app after use
export const deleteSecondaryApp = async (): Promise<void> => {
  try {
    const secondaryApp = getApp('secondary');
    await deleteApp(secondaryApp);
  } catch {
    // App doesn't exist, nothing to delete
  }
};

export { app, storage, auth, db };
